import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PopoverService } from '../../../components/popover/popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import icPerson from '@iconify/icons-ic/twotone-person';
import icMore from '@iconify/icons-ic/twotone-more-horiz';
import { UserSettingService } from '../../../../@vex/services/userSettingService/userSetting.service';
import { set } from 'date-fns';

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit {

  dropdownOpen: boolean;
  icPerson = icPerson;
  icMore = icMore;
  loginUserData;
  profileImage;
  constructor(
    private popover: PopoverService,
    private cd: ChangeDetectorRef,
    private _userSettingServce: UserSettingService) {

  }

  ngOnInit() {
    this._userSettingServce.ValueForChangeProfilePicGlobally.subscribe(data => {
      if (data !== 'ok') {
        this.loginUserData = JSON.parse(localStorage.getItem('UserInfo'));
        this.cd.detectChanges()
      }
    })
    this.loginUserData = JSON.parse(localStorage.getItem('UserInfo'));
    this.profileImage = this.loginUserData.Avatar.replace("$#$", "");
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }

  checkURL(url) {
    return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
  }

}
